export default __webpack_public_path__ + "static/media/azmayeshgah.01c58a57.png";